/** @jsx h */
import { h } from 'preact';
import { useEffect } from 'preact/hooks';
import { createPresenter } from './presenter';
import {
  couponSvg,
  trackDisplay,
  trackRedeem,
  trackCopyToClipboard,
} from './data';
import { redeem } from '../new-offer-card/actions';
import { PromotionCardCodeRedemption } from '../exclusive-offer/card/code-section';
import { track, CLICK } from '@updater-core/lib/tracker';

import '@updater-components/card';
import '@updater-components/checkbox';
import '@updater-components/loading-spinner';

function handleRedeemGo(promotion) {
  trackRedeem(track, promotion);
  redeem(promotion, false);
}

function handleRedeemGoAndCopy(promotion) {
  trackCopyToClipboard(track);
  trackRedeem(track, promotion);
  redeem(promotion, true);
}

export function FymSelectOfferCard({
  code,
  name,
  source,
  claimedId,
  displayName,
  discountCode,
  selected,
  entityId,
  entityLogo,
  promotion,
  promotionId,
  promotionCode,
  eligiblePromotion,
  showCode,
  showNoCode,
  showGoBtn,
  showCopyGoBtn,
  claiming,
  redemptionUrl,
  onSelectedPromo,
}) {
  return (
    <upd-card
      onClick={() => {
        if (eligiblePromotion) {
          track({
            verb: CLICK,
            object: 'fym_offers_toggle',
            domain: 'promotions',
            details: {
              promotionId,
              entityId,
              code,
              promotionCode,
              promotion,
              source: 'forward_mail',
            },
          });

          onSelectedPromo(promotionId);
        }
      }}
    >
      <div
        class={
          !eligiblePromotion
            ? 'body claimed'
            : claiming
            ? 'body fym-promotion-card-disabled disabled'
            : 'body '
        }
      >
        {eligiblePromotion && (
          <upd-checkbox checked={selected} disabled={claiming} />
        )}
        <div class="img-container">
          <img id="entity-logo" src={entityLogo} />
        </div>
        <div class="details">
          <div class="name">{name}</div>
          <div class="description">{displayName}</div>
        </div>
      </div>
      {!eligiblePromotion && (
        <div class="footer">
          <div class="claimed-btn-group">
            <PromotionCardCodeRedemption
              {...{
                code,
                source,
                discountCode,
                redemptionUrl,
                promotionId,
                claimedId,
                entityId,
                promotionCode,
                showCode,
                showNoCode,
                showGoBtn,
                showCopyGoBtn,
                handleRedeemGo,
                handleRedeemGoAndCopy,
              }}
            />
          </div>
        </div>
      )}
    </upd-card>
  );
}

export function FymSelectOfferCards({
  moveId,
  promos,
  noPromos,
  claiming,
  source,
  goToEOPage,
  togglePromoSelection,
  loading,
  children,
}) {
  useEffect(() => {
    trackDisplay(track, promos);
  }, [loading]);

  const confirmationHeader = noPromos
    ? 'You have no deals claimed'
    : 'Use the deals you claimed';
  const confirmationText = noPromos
    ? 'Click below to browse more offers and get special deals!'
    : 'You’ve claimed the exclusive discounts for your move. Start using them now while your address change is being processed.';

  const fymSelectOfferCardItems = promos
    ? promos.map((promo) => (
        <FymSelectOfferCard
          key={promo.promotion.id}
          {...createPresenter(promo, moveId)}
          claiming={claiming}
          source={source}
          onSelectedPromo={togglePromoSelection}
        />
      ))
    : '';

  return (
    <div class="fym-promotion-component">
      <div class="fym-promotion-divider" />
      <div class="fym-promotion-intro">
        <div class="local-deals-header">
          <div dangerouslySetInnerHTML={{ __html: couponSvg }} />
          {source === 'fym_details' ? (
            <p>Claim moving discounts</p>
          ) : (
            <p>{confirmationHeader}</p>
          )}
        </div>
        {source === 'fym_details' ? (
          <p>
            Claim exclusive savings we've picked just for you and get the codes
            sent to your inbox.
          </p>
        ) : (
          <p>{confirmationText}</p>
        )}
      </div>
      {loading ? (
        <div class="loading-promotions">
          <upd-loading-spinner />
        </div>
      ) : (
        fymSelectOfferCardItems
      )}
      {source !== 'confirmation' && (
        <div class="disclaimer">
          Brands you select may contact you related to this offer and your move.
        </div>
      )}
      {source !== 'confirmation' ? (
        children
      ) : (
        <upd-cta primary class="fixed-width">
          <button
            rel="noopener"
            target="_blank"
            onClick={() => {
              // go to browse offers
              goToEOPage();
            }}
          >
            Browse more offers
          </button>
        </upd-cta>
      )}
    </div>
  );
}
